import React, { useState, useEffect } from 'react';
import { getSoyLateAdjustedGroups, getSoyLateStats } from '../../lib/api';
import { AdjustmentTab } from '../../components/AdjustmentTab';
import { getChartColors } from '../../services/chart-colors';

export function LateAdjustmentsTab(props) {
  const {
    onLoad,
    onGroupsAdjustment,
    onFieldAdjustment,
    field,
    ...passThrough
  } = props;

  const [stats, setStats] = useState(null);
  const [fieldAdjustment, setFieldAdjustment] = useState(0);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    Promise.all([
      getSoyLateStats(field.aaManagedId),
      getSoyLateAdjustedGroups(field.aaManagedId),
    ])
      .then(([lateStats, lateGroups]) => {
        if (lateStats) {
          setStats(lateStats);
          setGroups(lateGroups);
          setFieldAdjustment(field.lateAdjustmentFactor || 0);
        }

        onLoad('late', lateGroups, field.lateAdjustmentFactor);
      })
      .catch(() => onLoad('late'));
  }, [field, onLoad]);

  return (
    stats && (
      <AdjustmentTab
        {...passThrough}
        floor={120000}
        ceiling={220000}
        multipleOf={5000}
        stats={stats}
        groups={groups}
        fieldAdjustment={fieldAdjustment}
        colors={getChartColors('soyrx-late')}
        xLabel="Rate"
        onGroupsAdjustment={(newGroups) =>
          onGroupsAdjustment('late', newGroups)
        }
        onFieldAdjustment={(adjustment) =>
          onFieldAdjustment('late', adjustment)
        }
      />
    )
  );
}
